import { useServiceClient } from 'bz-stores/hooks/service-client';
import createContext from 'bz-utilities/hooks/context-v2';
import { memo, type PropsWithChildren, useEffect, useState } from 'react';
import { TasksAvailableUsers, type UserRoleLocationWithUserName } from 'tm3-core/api.dtos';

export const [TaskUsersContext, useTaskUsers] =
  createContext<UserRoleLocationWithUserName[]>('TaskUsers');

export const TaskUsersProvider = memo(({ children }: PropsWithChildren) => {
  const client = useServiceClient();
  const [users, setUsers] = useState<UserRoleLocationWithUserName[]>([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const res = await client.get(new TasksAvailableUsers());
      setUsers(res);
    };
    fetchUsers();
  }, [client]);

  return <TaskUsersContext.Provider value={users}>{children}</TaskUsersContext.Provider>;
});
